// ============================================================================
// REPOSITORY: BillingGeneratorRepository — geração de faturas em batch
// ARQUIVO: src/services/BillingGeneratorRepository.js
// ============================================================================

import { collection, doc, writeBatch, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

const DEFAULT_APP_ID = 'portalrda-f312d';

export async function generateInvoiceId(appId = DEFAULT_APP_ID) {
  const ref = doc(collection(db, ...FS.invoices(appId)));
  return ref.id;
}

export async function saveInvoicesBatch(invoices, appId = DEFAULT_APP_ID) {
  const invoicesWithTimestamp = invoices.map((inv) => ({
    ...inv,
    createdAt: serverTimestamp(),
  }));
  try {
    const batch = writeBatch(db);
    invoicesWithTimestamp.forEach((inv) => {
      batch.set(doc(db, 'invoices', inv.invoiceId), inv);
    });
    await batch.commit();
    return { fallback: false };
  } catch {
    const batch = writeBatch(db);
    invoicesWithTimestamp.forEach((inv) => {
      batch.set(doc(db, ...FS.invoices(appId), inv.invoiceId), inv);
    });
    await batch.commit();
    return { fallback: true };
  }
}
